<div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center mb-8">
  <h1 class="font-bold mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-full">{{ { key: 'profile', n: 1 } | i18n }}</h1>
  <div class="mt-4 sm:mt-0 flex-shrink-0">
    <a
      [href]="'https://' + organizationKey + '.b-bit.cloud/account'"
      target="_blank"
      class="block cursor-pointer items-center justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
    >
      {{ { key: 'manageMyAccount' } | i18n }}
    </a>
  </div>
</div>

<div class="flex flex-col gap-8">
  <div class="flex flex-col">
    <div class="text-xs mb-2 text-gray-500">{{ { key: 'eMail' } | i18n }}</div>
    <div class="whitespace-pre-line">{{ (profile | async)?.eMail }}</div>

    <div class="mt-4">
      <a
        [href]="'https://' + organizationKey + '.b-bit.cloud/account'"
        target="_blank"
        class="items-center w-auto justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
      >
        {{ { key: 'changeEMail' } | i18n }}
      </a>
    </div>
  </div>

  <div class="flex flex-col">
    <div class="text-xs mb-2 text-gray-500">{{ { key: 'password' } | i18n }}</div>

    <div class="mt-4">
      <a
        [href]="'https://' + organizationKey + '.b-bit.cloud/account'"
        target="_blank"
        class="items-center w-auto justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
      >
        {{ { key: 'changePassword' } | i18n }}
      </a>
    </div>
  </div>

  <div class="flex flex-col">
    <div class="text-xs mb-2 text-gray-500">{{ { key: 'address' } | i18n }}</div>
    <div class="whitespace-pre-line">{{ addressObs | async }}</div>

    <!-- <div class="mt-4">
      <a
        [href]="'https://' + organizationKey + '.b-bit.cloud/account'"
        target="_blank"
        class="items-center w-auto justify-center border border-transparent py-2 px-4 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
      >
        {{ { key: 'changeAddress' } | i18n }}
      </a>
    </div> -->
  </div>
</div>
